export default {
  app: 'APP_RECOVER',
  api: '/portal'
};
